import * as React from 'react'
import MobileBottomNav from './MobileBottomNav'
import {useNotificationCount} from '../../hooks/useNotificationCount'

const MobileBottomNavWrapper = () => {
  const {displayCount} = useNotificationCount({poll: true})
  return <MobileBottomNav count={displayCount} />
}

export default React.memo(MobileBottomNavWrapper)
